import { useState, useRef, useEffect } from "react";
import { selectUser, selectLocation } from "../store/auth";
import { useSelector } from "react-redux";
import { useTranslation } from "../i18n";

/**
 * @returns {React.Component}
 */
export default function UserInfo() {
  const user = useSelector(selectUser);
  const location = useSelector(selectLocation);
  const { t, locale, setLocale } = useTranslation();
  const [showSettings, setShowSettings] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShowSettings(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    user && (
      <div className="relative">
        {/* Avatar button */}
        <div
          className="flex p-0 flex-row space-x-4 items-center h-16 cursor-pointer"
          onClick={() => setShowSettings(!showSettings)}
        >
          <div className="text-xl h-12 w-12 text-white rounded-full bg-c-gray-600 flex items-center justify-center">
            {user.firstname[0]}
            {user.lastname[0]}
          </div>
          <div className="min-w-0">
            <h1 className="whitespace-nowrap">
              {user.firstname} {user.lastname}
            </h1>
            <p className="text-c-gray-400 whitespace-nowrap">
              {location?.name || ""}
            </p>
          </div>
        </div>

        {/* Settings popover */}
        {showSettings && (
          <div
            ref={popoverRef}
            className="absolute top-full left-0 mt-2 w-48 bg-c-gray-700 border border-c-gray-500 rounded-lg shadow-lg z-50 p-3"
          >
            <label className="text-c-gray-400 text-sm block mb-2">
              {t("language.select")}
            </label>
            <div className="flex flex-col space-y-1">
              <button
                className={`w-full text-left px-3 py-2 rounded-md text-sm ${
                  locale === "ru"
                    ? "bg-accent text-white"
                    : "text-white hover:bg-c-gray-600"
                }`}
                onClick={() => {
                  setLocale("ru");
                  setShowSettings(false);
                }}
              >
                {t("language.ru")}
              </button>
              <button
                className={`w-full text-left px-3 py-2 rounded-md text-sm ${
                  locale === "en"
                    ? "bg-accent text-white"
                    : "text-white hover:bg-c-gray-600"
                }`}
                onClick={() => {
                  setLocale("en");
                  setShowSettings(false);
                }}
              >
                {t("language.en")}
              </button>
            </div>
          </div>
        )}
      </div>
    )
  );
}
